export enum LoopType {
    AnyLoop,
    Fluid,
    Poll,
    VideoRecord,
    Planner,
    Card,
}
